import React , { useState , useRef  , useMemo }from 'react'  ;
import routes from 'js/Routes.js';
import LazyPageLoader from 'js/LazyPageLoader.js';

import GeneralLoadingPage from 'js/Pages/GeneralLoadingPage.js';
import {
    useNavigate  ,
  } from "react-router-dom";


const routeUrlToPageLoader = ( location , changeUpdater , startupData  , appReducer) => {
    for( let i = 0 ; i < routes.length ; i++ ){
        if( routes[i].routesToLocation(location) ){
            return routes[i].getPageLoaderModule( location , changeUpdater , startupData  , appReducer);
        }
    }
};

const routePageModuleStringToPageLoader = ( pageModuleString , location , changeUpdater , startupData , appReducer) => {
    for( let i = 0 ; i < routes.length ; i++ ){
        if( routes[i].routesToModuleNameString(pageModuleString ) ){
            return routes[i].getPageLoaderModule( location , changeUpdater , startupData  , appReducer );
        }
    }
};

const RouterReducer = ( currentPage , prevPage , navigate  , trackChange )=>{
    let reducer = {};

    reducer.setCurrentPageModule = function( module ){
        if( currentPage.current ){
            prevPage.current = currentPage.current;
        }
        if( module.setOnUpdate ){
            module.setOnUpdate(trackChange);
        }
        currentPage.current = module;
        trackChange();
    };

    reducer.routeTo_byPageModuleString = function( moduleString , location , startupData ){

    };

    reducer.routeTo_byLocation = function( location , startupData ){

    };

    reducer.routeTo_withModule = function( module , location  ){
        reducer.setCurrentPageModule(module);
        navigate(location);
    };

    return reducer;
}


const useRouter = (  locationNow ,   appData  , appReducer )=> {
    let navigate  = useNavigate ();

    const trackChange = ()=>{
        setChangeTrack(new Date());
    };
    const [ changeTrack , setChangeTrack ] = useState(0);
    const [ lastCheckAfterOffline , setLastCheckAfterOffline ]  = useState();
    const currentPage = useRef(null);
    const prevPage = useRef(null);
    const prevLocation = useRef(null);
    const currentLocation = useRef(null);

    useMemo(() => {
        if( currentLocation.current ){
            prevLocation.current = currentLocation.current;
        }
        currentLocation.current = locationNow;

        if( !currentPage.current ){
            if( appData?.currentPageData?.pageModule ){
                currentPage.current = routePageModuleStringToPageLoader(appData.currentPageData.pageModule , locationNow , () => {  console.log('track change');  setChangeTrack( new Date() )} , ( appData.currentPageData ?? null));
            } else {
                currentPage.current = routeUrlToPageLoader(locationNow , () => {setChangeTrack( new Date() )} , ( appData?.currentPageData ?? null)  , appReducer);
            }
        } else {
            // check if current module can handle request
            if(    currentPage.current.canHandleRequest && currentPage.current.canHandleRequest( locationNow )  ){
                currentPage.current.handleRequest( locationNow );
            } else {
                prevPage.current = currentPage.current ;
                currentPage.current = routeUrlToPageLoader(locationNow , () => {  setChangeTrack( new Date() )} , null  , appReducer);
                window.scrollTo(0, 0);
            }
        }

        return [ locationNow.pathname + locationNow.search +  locationNow.hash , locationNow  ]
    } , [ locationNow.pathname + locationNow.search +  locationNow.hash , locationNow  ]);


    let showLoader = false;
    let shownPage = <GeneralLoadingPage />;
    let shownModule = null;
    if( currentPage.current?.isFullyLoaded() ){
        shownPage = currentPage.current.getRenderComponent();
        shownModule = currentPage.current;
    } else if ( prevPage.current?.isFullyLoaded ){
        showLoader = true;
        shownPage = prevPage.current.getRenderComponent();
        shownModule = prevPage.current;
        console.log('loader: !isFullyLoaded - show prev');
    } else if ( currentPage.current?.canBeShown()  ){
        showLoader = true;
        console.log('loader: !isFullyLoaded but shown');
        shownPage = currentPage.current.getRenderComponent();
        shownModule = currentPage.current;
    } else {
        showLoader = true;
        shownPage = <GeneralLoadingPage />;
    }


    return [ currentPage.current , prevPage.current , shownPage , showLoader , shownModule , RouterReducer( currentPage , prevPage , navigate  , trackChange) ];
}


export { routeUrlToPageLoader , routePageModuleStringToPageLoader , useRouter }
